module.exports = __webpack_public_path__ + "static/marco-12e3ec085c96887140c86160eba68382.jpg";